import type { BrandGuideVoice } from '@/contracts/onboarding-session';

/** The labelled lines of `dna.voice`, in reading order. Only entries that carry text are shown. */
const VOICE_LABELS: readonly (readonly [keyof BrandGuideVoice, string])[] = [
  ['positioningMore', 'We sound more'],
  ['positioningLess', 'We sound less'],
  ['wordsWeUse', 'Words we use'],
  ['wordsWeAvoid', 'Words we avoid'],
  ['associateWith', 'Associate with'],
  ['dontAssociateWith', "Don't associate with"],
  ['taglines', 'Taglines'],
  ['guidelinesNote', 'Guidelines'],
];

export function voiceEntries(voice: BrandGuideVoice | null | undefined): { key: string; label: string; text: string }[] {
  if (!voice) return [];
  return VOICE_LABELS.flatMap(([key, label]) => {
    const text = voice[key]?.trim();
    return text ? [{ key, label, text }] : [];
  });
}
